import { useTranslation } from 'next-i18next';
import classNames from 'classnames';

import {
  AuctionCard,
  Scrollable,
  TimerOld as Timer,
} from '@catawiki/cata-style';

import { Auctioneer } from '@/shared/models/auction';
import { cleanBuilderStringInput } from '@/shared/text';
import { formatDayMonth } from '@/shared/formatter';

export interface FeaturedAuction {
  id: number;
  href: string;
  title: string;
  curator: Auctioneer;
  mainImage: string;
  thumbImages: [string, string, string];
  numberOfLots: number;
  closeAt: number; // Timestamp
}

interface Props {
  title?: string;
  className?: string;
  auctions: FeaturedAuction[];
  hidden?: boolean;
}

export const FeaturedAuctions = ({
  title = 'Featured Auctions',
  auctions = [],
  className = '',
  hidden = false,
}: Props) => {
  const { t, i18n } = useTranslation();
  if (hidden) return null;

  return (
    <div className={classNames('p-feature-auctions', className)}>
      {title && (
        <h6 className="u-typography-h6 u-m-b-xl">
          {cleanBuilderStringInput(title, true)}
        </h6>
      )}
      <Scrollable listClassName="tw:items-center u-g-m">
        {auctions.map((auction) => {
          const timer = (
            <Timer
              timer={t('closes_on', {
                closed_on_date: formatDayMonth(
                  i18n.language,
                  new Date(auction.closeAt)
                ),
              })}
            />
          );
          const subTitle = `${t('auction_lane.curated_by')} ${
            auction.curator.name
          }`;
          return (
            <AuctionCard
              key={auction.id}
              subTitle={subTitle}
              {...auction}
              timer={timer}
            />
          );
        })}
      </Scrollable>
    </div>
  );
};
